// extracted by mini-css-extract-plugin
module.exports = {"menuPaper":"styles_menuPaper__1NNvi","menuList":"styles_menuList__3-XD-","item":"styles_item__2QN4d","itemSelected":"styles_itemSelected__2OE5V"};